<script>
  import { getNavState, getDrawerTop } from '../../../../../js/stores';
  import { drawerScrollClamp } from '../../../../../js/drawerScrollClamp';
  import { trackCdp } from '../../../../../js/tracking';

  export let toggle;
  export let drawerType = 'Menu';

  const navStateStore = getNavState();
  const drawerTopStore = getDrawerTop();

  let element;
  let isOpen = false;

  // When $navStateStore updates, if the current drawer
  // is not this element, close this drawer menu
  // to ensure only one drawer is open at a time.
  $: if (isOpen && $navStateStore.drawer !== element) {
    close();
  }

  function open() {
    element.scrollTop = 0;

    // force repaint to fix Safari scroll bug
    element.offsetHeight; // eslint-disable-line no-unused-expressions

    isOpen = true;

    $navStateStore = {
      ...$navStateStore,
      // set current drawer to this drawer
      drawer: element,
      // when a drawer opens, close any open category or subcategory
      category: null,
      subcategory: null,
    };

    trackCdp({ eventName: 'Open Drawer', properties: { drawerType } });
  }

  function close() {
    isOpen = false;

    $navStateStore = {
      ...$navStateStore,
      // if no other drawers are open, set current drawer to null
      drawer: $navStateStore.drawer === element ? null : $navStateStore.drawer,
      // when a drawer closes, close any open category or subcategory
      category: null,
      subcategory: null,
    };

    trackCdp({ eventName: 'Close Drawer', properties: { drawerType } });
  }

  function onToggle() {
    isOpen ? close() : open();
  }
</script>

<svelte:component this={toggle} {isOpen} on:toggle={onToggle} />

<!-- 
  NOTE:
  To ensure that the drawer is visibily hidden until the css is ready, 
  we use --drawer-visibility variable with hidden as default to toggle visibility
-->

<div
  class="Drawer"
  class:isOpen
  bind:this={element}
  style="top: {$drawerTopStore}px; visibility: var(--drawer-visibility, hidden)"
  use:drawerScrollClamp
>
  <slot />
</div>

<style>.Drawer {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  z-index: 1;
  display: block;
  position: fixed;
  overflow: auto;
  top: 73px;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 414px;
  margin: 0;
  padding-bottom: 100px;
  --drawer-visibility: hidden;
  transform: translate3d(100%, 0, 0);
  transition: visibility 0ms 200ms, transform 200ms cubic-bezier(0.4, 0, 1, 1);
}

.isOpen {
  z-index: 2;
  --drawer-visibility: visible;
  transform: translate3d(0, 0, 0);
  transition: visibility 0ms, transform 250ms cubic-bezier(0, 0, 0.2, 1);
}</style>
